import type { IconSvgObject } from './types';

const CaseSensitiveIcon: IconSvgObject = [
  ["path", { d: "M21.5 10V17M21.5 13.5C21.5 15.433 19.933 17 18 17C16.067 17 14.5 15.433 14.5 13.5C14.5 11.567 16.067 10 18 10C19.933 10 21.5 11.567 21.5 13.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 17L7.6857 7.46424C7.57354 7.18385 7.30198 7 7 7C6.69802 7 6.42646 7.18385 6.3143 7.46424L2.5 17M4 14H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CaseSensitiveIcon;
